exports = module.exports = require("../../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".AllTasksPage__AllTasksContainer__2XaNa {\n  font-size: 1.5rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column;\n      flex-flow: column;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n/* snackbar */\n.AllTasksPage__SnackbarLeft__2BDsA {\n  max-width: 300px;\n}\n\n.AllTasksPage__SnackbarRight__3-erF {\n  margin-left: 40px;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.AllTasksPage__UndoButton__1NJEJ {\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 5px;\n  cursor: pointer;\n  background-color: #eee;\n}\n\n.AllTasksPage__UndoButton__1NJEJ:hover {\n  background-color: #fff;\n}\n\n.AllTasksPage__UndoButton__1NJEJ:focus {\n  outline: none;\n}\n\n.AllTasksPage__CreateNewTaskButtonContainer__1rEHv {\n  position: fixed;\n  padding: 10px;\n  bottom: 0;\n  right: 0;\n}\n", ""]);

// exports
exports.locals = {
	"AllTasksContainer": "AllTasksPage__AllTasksContainer__2XaNa",
	"SnackbarLeft": "AllTasksPage__SnackbarLeft__2BDsA",
	"SnackbarRight": "AllTasksPage__SnackbarRight__3-erF",
	"UndoButton": "AllTasksPage__UndoButton__1NJEJ",
	"CreateNewTaskButtonContainer": "AllTasksPage__CreateNewTaskButtonContainer__1rEHv"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/containers/AllTasksPage/AllTasksPage.css
// module id = 644
// module chunks = 0